import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Logo, useAuth0 } from '@ondeck/silkworm';
import Profile from 'assets/profile.svg';
import { Navbar, Container, Stack, Button } from 'react-bootstrap';
import { useAppData } from 'contexts/appContext';

const ProfileWrapper = styled.div`
  height: 48px;
  margin: auto 16px auto 0;
`;

interface LoginProps {
  hasLogin?: boolean;
  partnerDetails?: { partner: string };
}

const Header = () => {
  const { logout } = useAuth0();
  const { hasLogin, partnerDetails }: LoginProps = useAppData();
  const logoutUrl = `${window.env.REACT_APP_AUTH0_REDIRECT_URI}/login?message=sign-out`;
  return (
    <Navbar collapseOnSelect expand="md" bg="light" variant="light" style={{ zIndex: 1200 }}>
      <Container>
        <Navbar.Brand className="me-0">
          <Stack direction="horizontal" gap={1}>
            <Logo/>
            <h1 className="pt-md-3 ms-1 mb-md-1 text-black-50 fw-400" style={{ marginBottom: '-10px' }}>
              Partner Portal
            </h1>
          </Stack>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        {hasLogin && (
          <Navbar.Collapse id="responsive-navbar-nav" data-testid="Hamburger">
            <Stack className="ms-auto d-none d-md-flex" direction="horizontal" gap={1}>
              <span>{partnerDetails.partner}</span>
              <ProfileWrapper>
                <img src={Profile} alt="profile" />
              </ProfileWrapper>
              <Button variant="outline-secondary" size="sm"
                onClick={() => logout(logoutUrl)}
                data-testid="signout-lg"
              >
                <FormattedMessage id="common.signOut" />
              </Button>
            </Stack>
            <Button className="w-100 py-2 mt-2 d-block d-md-none" variant="primary" size="sm"
              onClick={() => logout(logoutUrl)}
              data-testid="signout-sm"
            >
              <FormattedMessage id="common.signOut" />
            </Button>
          </Navbar.Collapse>
        )}
      </Container>
    </Navbar>
  );
};

export default Header;
